<template>
  <div class="py-3">
    <div class="mb-5">
      <div class="align-self-center" style="min-width: 160px"><b>Order Product</b></div>
    </div>
    <div class="d-flex justify-center align-center">
      <v-tabs v-model="tab" color="primary" background-color="#F5F5F5" grow>
        <v-tab :class="{ buttonEffectTab: tab === 0 }">Order</v-tab>
        <v-tab :class="{ buttonEffectTab: tab === 1 }">Cart</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <ProductSelector
              ref="productSelector"
              :categories="categories"
              :selectedProducts="selectedProducts"
            >
            </ProductSelector>
          </v-tab-item>
          <v-tab-item>
            <div>
              <template>
                <v-divider class="mt-3" />
                <v-row class="d-flex align-center justify-center justify-space-between">
                  <v-col cols="2"></v-col>
                  <v-col cols="2">Product Name</v-col>
                  <v-col cols="2">Category</v-col>
                  <v-col cols="2">Unit Price</v-col>
                  <v-col cols="1">Quantity</v-col>
                  <v-col cols="1">SubTotal</v-col>
                  <v-col cols="1"></v-col>
                </v-row>
                <v-divider />
              </template>
            </div>
            <div v-for="product in selectedProducts" :key="product._id">
              <cart-item-row
                :item="product"
                :productCategories="categories"
                :hideBinIcon="isBookingCompleted"
                @remove="remove"
              ></cart-item-row>
              <v-divider class="my-3" />
            </div>
            <div class="d-flex flex-end justify-end">
              <h4>Sub-Total:</h4>
              <h4 class="ml-3">HK$ {{ computedSubTotal }}</h4>
            </div>
            <div class="d-flex flex-end justify-end align-center mt-2">
              <h4>Discount:</h4>
              <div style="width: 140px" class="ml-3">
                <v-text-field
                  hide-details
                  suffix=" % off"
                  type="number"
                  outlined
                  persistent-hint
                  dense
                  :value="docs.purchasedProductDiscount"
                  @input="
                    x => {
                      this.$set(this.docs, 'purchasedProductDiscount', Math.min(100, Math.abs(x)));
                    }
                  "
                >
                </v-text-field>
              </div>
            </div>
            <div class="d-flex flex-end justify-end mt-2">
              <h4>Total:</h4>
              <h4 class="ml-3">HK$ {{ computedTotal }}</h4>
            </div>
            <div class="d-flex flex-end justify-end mt-2">
              <v-btn
                color="primary"
                @click="promptSaveProductOrder"
                :disabled="!masterHasAuth || isBookingCompleted"
                >Submit To Invoice
              </v-btn>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { attnThumbHref } from '@/services/filters';
import { get, debounce } from 'lodash';
import { listPhysicalProducts } from '@/api/productCategory';
import api from '@/api';
import CartItemRow from '@/components/ServiceDetails/CartItemRow';
import { BookingStatus, patchPurchasedProducts } from '@/api/bookings';
import LoadMoreButton from '@/components/LoadMoreButton';
import { getOid } from '@/services/utils';
import { mapGetters } from 'vuex';
import ProductSelectionCard from '@/components/PhysicalProduct/ProductSelectionCard.vue';
import ProductSelector from '@/components/PhysicalProduct/ProductSelector.vue';

export default {
  name: 'ProductCategoryList',
  components: { CartItemRow, ProductSelector },
  props: {
    id: String,
    categories: [],
    booking: {},
    docs: {},
    selectedProducts: [],
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['isMaster', 'profileId', 'isAdmin', 'isCashier']),
    computedSubTotal() {
      let total = 0;
      this.selectedProducts.map(el => {
        el.discountedPrice
          ? (total += el.discountedPrice * el.selectedQty)
          : (total += el.listedPrice * el.selectedQty);
      });
      return Number(total.toFixed(2));
    },
    computedTotal() {
      const total = this.computedSubTotal * (1 - (this.docs.purchasedProductDiscount || 0) / 100);
      return Number(total.toFixed(2));
    },
    masterHasAuth() {
      return (
        this.isAdmin ||
        this.isCashier ||
        (this.isMaster && this.profileId === getOid(this.docs?._timetable?.master))
      );
    },
    isBookingCompleted() {
      return this.booking?.status === BookingStatus.completed;
    },
  },
  watch: {
    booking: {
      handler(v) {
        if (v?.purchasedProducts?.length > 0) {
          const list = v.purchasedProducts.map(el => ({
            ...el.product,
            checkbox: true,
            selectedQty: el.qty,
          }));
          this.$emit('updateCart', list);
        }
      },
    },
  },
  methods: {
    get,
    attnThumbHref,
    async promptSaveProductOrder() {
      let orderProducts = [];
      this.selectedProducts.map(el =>
        orderProducts.push({
          product: el._id,
          qty: el.selectedQty,
          // deprecated
          // amountPayable: el.discountedPrice
          //   ? el.discountedPrice * el.selectedQty
          //   : el.listedPrice * el.selectedQty,
        }),
      );
      try {
        const model = await patchPurchasedProducts(
          api,
          this.id,
          orderProducts,
          this.docs.purchasedProductDiscount || 0,
        );
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Saved',
          type: 'success',
          color: 'success',
        });
        this.$emit('submit', model);
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    remove(item) {
      this.$refs.productSelector.remove(item);
      // product checkbox set false on recommendation list
      this.$emit('remove', item);
    },
  },
};
</script>

<style lang="scss">
.buttonEffectTab {
  background-color: var(--v-primary-base) !important;
  padding: 0 12px !important;
  color: white !important;
}
</style>
